import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.startY = 0;
    this.moved = false;
  }

  touchstart(event) {
    this.startY = event.touches[0].clientY;
    this.moved = false;
  }

  touchmove(event) {
    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.startY;

    if (deltaY < -20) {
      this.moved = true;
      this.element.style.transform = `translate(-50%, ${deltaY}px)`;
    }
  }

  touchend() {
    if (this.moved) {
      this.element.style.transition = "transform 0.2s ease, opacity 0.2s ease";
      this.element.style.transform = "translate(-50%, -100px)";
      this.element.style.opacity = "0";

      setTimeout(() => {
        this.element.remove();
      }, 200);
    } else {
      this.element.style.transform = "translate(-50%, 0)";
    }
  }
}
